var _rect, _path, _path2, _path3, _path4, _path5, _text, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCssPartnerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 32,
    viewBox: "0 0 177 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.00586,
    width: 14.0184,
    height: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.736842 0.736842C0 1.47368 0 2.52632 0 2.52632V29.4737C0 29.4737 0 30.5263 0.736842 31.2632C1.47368 32 2.31579 32 2.31579 32H29.5789C29.5789 32 30.5263 32 31.2632 31.2632C32 30.5263 32 29.4737 32 29.4737V2.42105C32 2.42105 31.8491 1.35437 31.3684 0.842105C30.8513 0.290964 29.5789 0 29.5789 0H2.42105L2.37156 0.00184427C2.37156 0.00184427 1.37364 0.100044 0.736842 0.736842ZM20.6947 5.89474H11.2842C10.6316 5.85263 10.1053 5.30526 10.1053 4.63158C10.1053 3.95789 10.6316 3.41053 11.3053 3.36842H14.3158V3.34737C14.3158 2.42105 15.0737 1.66316 16 1.66316C16.9263 1.66316 17.6842 2.42105 17.6842 3.34737V3.36842H20.6947C21.3684 3.41053 21.8947 3.95789 21.8947 4.63158C21.8947 5.30526 21.3684 5.85263 20.6947 5.89474Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.736842 0.736842C0 1.47368 0 2.42105 0 2.42105V7.57895H32V2.52632C32 2.52632 32.1052 1.68421 31.3684 0.842105C30.6316 2.00774e-07 29.5789 0 29.5789 0H2.42105C2.42105 0 1.47368 -5.01934e-08 0.736842 0.736842ZM20.6947 5.89474H11.2842C10.6316 5.85263 10.1053 5.30526 10.1053 4.63158C10.1053 3.9579 10.6316 3.41053 11.3053 3.36842H14.3158V3.34737C14.3158 2.42105 15.0737 1.66316 16 1.66316C16.9263 1.66316 17.6842 2.42105 17.6842 3.34737V3.36842H20.6947C21.3684 3.41053 21.8947 3.9579 21.8947 4.63158C21.8947 5.30526 21.3684 5.85263 20.6947 5.89474Z",
    fill: "#3F51B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29.4737V2.52632C32 1.13684 30.8632 0 29.4737 0H2.52632C1.13684 0 0 1.13684 0 2.52632V29.4737C0 30.8632 1.13684 32 2.52632 32H29.4737C30.8632 32 32 30.8632 32 29.4737ZM20.6947 5.89474H11.2842C10.6316 5.85263 10.1053 5.30526 10.1053 4.63158C10.1053 3.95789 10.6316 3.41053 11.3053 3.36842H14.3158V3.34737C14.3158 2.42105 15.0737 1.66316 16 1.66316C16.9263 1.66316 17.6842 2.42105 17.6842 3.34737V3.36842H20.6947C21.3684 3.41053 21.8947 3.95789 21.8947 4.63158C21.8947 5.30526 21.3684 5.85263 20.6947 5.89474Z",
    fill: "url(#paint0_radial)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9705 16.1589C27.1438 17.16 24.9684 20.7408 24.7758 20.9526L22.8507 25.9772C22.1769 26.3045 20.2517 26.8628 19.7704 27.1131C19.5394 27.2286 7.64194 28.1527 7.43018 27.9987L10.5069 32C10.5069 32 27.5172 32 29.5194 32C29.5194 32 32.5214 32 32.021 28.5C32.021 26.7481 32.021 22.5 32.021 22.5",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3875 15.9857L16.7864 9.07438C16.5939 8.7856 16.2474 8.63159 15.9201 8.63159C15.5928 8.63159 15.2463 8.7856 15.0538 9.09363L10.4526 15.9857H5.42798C4.85043 15.9857 4.38839 16.4477 4.36914 17.006C4.36914 17.1023 4.36914 17.2178 4.40764 17.3141L7.08361 27.1131C7.33388 27.9987 8.14245 28.6532 9.10503 28.6532H22.7544C23.717 28.6532 24.5255 27.9987 24.7758 27.1131L27.4518 17.3333L27.4903 17.0445C27.4903 16.467 27.009 15.9857 26.4315 15.9857H21.3875ZM12.7436 15.9857L15.9201 11.3268L19.0966 16.005H12.7436V15.9857ZM15.9201 24.4179C14.765 24.4179 13.8024 23.4553 13.8024 22.3002C13.8024 21.1451 14.7457 20.1825 15.9201 20.1825C17.0944 20.1825 18.0378 21.1451 18.0378 22.3002C18.0378 23.4553 17.0752 24.4179 15.9201 24.4179Z",
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 24,
    fill: "#000000",
    fontSize: 20,
    fontWeight: 600,
    fontFamily: "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif"
  }, "CSS Partner")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.05264 0.421063) scale(42.807)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16.107,
    y1: 20.9875,
    x2: 26.7482,
    y2: 31.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssPartnerLogo);
export default __webpack_public_path__ + "static/media/css_partner_logo.322e50a9e5fb2c62dc19152be2103c60.svg";
export { ForwardRef as ReactComponent };